import { client } from "./axiosConfig";

export const postHelp = (data) => {
    return client.post("/submit-help-request", data);
};

export const postFeatureSuggestion = (data) => {
    return client.post("/submit-feature-suggestion", data);
};